import { Instance, types } from "mobx-state-tree";

import PrecipSensor from "./PrecipSensor";
import { SensorDisplayPrecip, SensorDisplayStream } from "./SensorDisplay";
import { StreamSensor } from "./StreamSensor";


const {
    compose,
    enumeration,
    literal,
    model,
    reference,
    union,
} = types;

export const SelectedPane = enumeration("selected", ["summary", "tabular", "chart"]);

const SelectedSensorBase = model({
    pane: SelectedPane,
});

export const SelectedPrecipSensor = compose(
    SelectedSensorBase,
    model({
        type: literal("precip"),
        sensor: reference(PrecipSensor),
        display: SensorDisplayPrecip,
    })
).named("SelectedPrecipSensor");
export type ISelectedPrecipSensor = Instance<typeof SelectedPrecipSensor>;

export const SelectedStreamSensor = compose(
    SelectedSensorBase,
    model({
        type: literal("stream"),
        sensor: reference(StreamSensor),
        display: SensorDisplayStream,
    })
).named("SelectedStreamSensor");
export type ISelectedStreamSensor = Instance<typeof SelectedStreamSensor>;

export const SelectedSensor = union(SelectedPrecipSensor, SelectedStreamSensor);
export type ISelectedSensor = Instance<typeof SelectedSensor>;